module.exports = __webpack_public_path__ + "img/step_7.ad892368.svg";